<template>
  <v-combobox
    ref="combobox"
    v-model="model"
    v-bind="$attrs"
    :items="items"
    @change="onChange"
  ></v-combobox>
</template>


<script>
import validationMixin from '@/mixins/validation.mixin'


export default {
  mixins: [
    validationMixin
  ],


  props: {
    value: {
      type: undefined
    },
    items: {
      type: Array
    }
  },


  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        let emitValue = val

        if (this.$attrs.hasOwnProperty('multiple') && this.$attrs.multiple !== false) {
          emitValue = this.toValidArray(val)
        }

        this.$emit('input', emitValue)
      }
    }
  },


  methods: {
    onChange () {
      this.$refs.combobox.lazySearch = ''
    },

    toValidArray (array) {
      let validArray = array.filter((item) => {
        return !this.isFalseOrWhitespace(item)
      })

      const itemTextProp = this.$attrs['item-text']

      validArray = validArray.map(item => {
        if (typeof item === 'object') return item

        item = item.trim()
        const existingItem = this.items.find(x => x[itemTextProp] === item)
        return existingItem ?? item
      })

      return validArray
    },

    provideFocus () {
      this.$refs.combobox.focus()
    }
  },


  mounted () {
    this.$el.onfocus = this.provideFocus
  }
}
</script>
